export const HOME = {
  emergentLink: "home-emergent-link",
};

export const LANDING = {
  page: "landing-page",
  headerLogo: "header-logo",
  heroBadge: "hero-badge",
  heroHeadline: "hero-headline",
  heroParagraph: "hero-paragraph",
  heroEmailInput: "hero-email-input",
  heroCtaButton: "hero-cta-button",
  heroSocialProof: "hero-social-proof",
  heroImage: "hero-image",
  wearablesBar: "wearables-bar",
  featuresHeadline: "features-headline",
  featureCard: (key) => `feature-card-${key}`,
  earlyAccessSection: "early-access-section",
  earlyAccessTitle: "early-access-title",
  earlyAccessName: "early-access-name-input",
  earlyAccessEmail: "early-access-email-input",
  earlyAccessGoal: "early-access-goal-select",
  earlyAccessGoalTrigger: "early-access-goal-trigger",
  earlyAccessSubmit: "early-access-submit-button",
  earlyAccessSpamNote: "early-access-spam-note",
  earlyAccessPerk: (key) => `early-access-perk-${key}`,
  footer: "footer",
  footerLogo: "footer-logo",
  footerPrivacy: "footer-privacy-link",
  footerContact: "footer-contact-link",
  footerSocial: (key) => `footer-social-${key}`,
};
